import $i18n from '@/locales/i18n';
import Icon from './logo';
const CnLayoutRowPrototype = {
    title: $i18n.get({ id: 'Line', dm: '行' }),
    componentName: 'CnLayoutRow',
    icon: Icon,
    docUrl: '',
    isContainer: true,
    configure: [
        {
            name: 'isCnLayoutRow',
            title: 'CnLayoutRow',
            initialValue: true,
            display: 'none',
        },
        {
            name: '_context',
            title: $i18n.get({ id: 'Context', dm: '上下文' }),
            initialValue: {
                type: 'JSExpression',
                value: 'this',
            },
            display: 'none',
        },
    ],
};
// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype
export { CnLayoutRowPrototype };
